import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../../utils';

export interface SetStorageOption extends Partial<GeneralInvokeOption> {
  key: string;
  data: any;
  encrypt?: boolean;
}

// 将数据存储在本地缓存指定key中
export function setStorage(option: SetStorageOption) {
  if (!option?.key || !option.data) {
    return logErrorAndRunFail(
      APINames.Native.SET_STORAGE,
      option,
      'parameter error:parameter.key or parameter.data should not be Undefined.'
    );
  }
  const fixedOption = Object.assign({ encrypt: false }, option);
  return MacleJSBridge.beforeInvoke(APINames.Native.SET_STORAGE, fixedOption);
}
